import(/* webpackMode: "eager" */ "/vercel/path0/src/app/corporate-law-services-detail-page/page.tsx");
